import styled from '@emotion/styled';
import { Inbox } from 'lucide-react';

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1.25rem;
  margin: 1.25rem 0;
  border: 1px dashed rgba(148, 163, 184, 0.6);
  border-radius: 0.75rem;
  background-color: rgba(241, 245, 249, 0.6);
  text-align: center;
`;

export const EmptyStateIcon = styled(Inbox)`
  width: 3rem;
  height: 3rem;
  color: #94a3b8;
  margin-bottom: 1.25rem;
`;

export const EmptyStateText = styled.p`
  color: #64748b;
  font-size: 0.95rem;
  line-height: 1.5;
`;

export const ResourceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.5rem;
`;

export const ResourceItemRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.9rem 1.1rem;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 0.75rem;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
`;

export const ResourceInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
`;

export const ResourceName = styled.a`
  font-weight: 600;
  color: #0f172a;
  text-decoration: none;
  word-break: break-all;

  &:hover {
    text-decoration: underline;
  }
`;

export const ResourceMeta = styled.span`
  font-size: 0.85rem;
  color: #64748b;
`;

export const ResourceActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.65rem;
  border-radius: 0.5rem;
  font-size: 0.85rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background-color: #fff;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover:not(:disabled) {
    border-color: rgba(37, 99, 235, 0.6);
    color: #1d4ed8;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
`;

export const HeaderTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 600;
  color: #0f172a;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SummaryText = styled.span`
  font-size: 0.85rem;
  color: #64748b;
`;
